import NoContactNotes from './NoContactNote';

export default NoContactNotes;
